import { getAuthToken } from '@/assets/js/Authentication'
import HttpRequest from './HttpRequest'

class StockLocationProvider extends HttpRequest {
  mappingLocation (payload) {
    this.setHeader(getAuthToken())
    return this.post('/stock-location/mapping', payload)
  }

  setMappingQty (payload) {
    this.setHeader(getAuthToken())
    return this.patch('/stock-location/mapping/set-mapping-qty', payload)
  }

  getProductLocation (payload) {
    this.setHeader(getAuthToken())
    return this.get('/stock-location/mapping/code', payload)
  }

  getMappingLocationPaginate (query) {
    this.setHeader(getAuthToken())
    return this.get('/stock-location/mapping', query)
  }

  getLocationMappingPaginateByCodes (body) {
    this.setHeader(getAuthToken())
    return this.post('/stock-location/mapping/by-codes', body)
  }

  exportLocationProduct (query) {
    this.setHeader(getAuthToken())
    return this.get('/stock-location/mapping/export-location-product', query)
  }

  moveLocation (payload) {
    this.setHeader(getAuthToken())
    return this.patch('/stock-location/mapping/move-location', payload)
  }

  clearLocation (payload) {
    this.setHeader(getAuthToken())
    return this.put('/stock-location/mapping/clear-location', payload)
  }

  createLocations (payload) {
    this.setHeader(getAuthToken())
    return this.post('/stock-location/master', payload)
  }

  exportAllLocation (payload) {
    this.setHeader(getAuthToken())
    return this.get('/stock-location/master/export-all-location', payload)
  }

  getLocationById (id) {
    this.setHeader(getAuthToken())
    return this.get(`/stock-location/master/${id}`)
  }

  getLocationPaginate (query) {
    this.setHeader(getAuthToken())
    return this.get('/stock-location/master', query)
  }

  getLocationMappingPaginate (query) {
    this.setHeader(getAuthToken())
    return this.get('/stock-location/master/mapping', query)
  }
}

export default StockLocationProvider
